// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2b4fF","errors":"Errors_errors__1rRlC"};